import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Paper, 
  Tabs, 
  Tab, 
  Typography, 
  Breadcrumbs, 
  Link,
  Grid
} from '@mui/material';
import { 
  AccountTree as AccountTreeIcon, 
  BarChart as BarChartIcon 
} from '@mui/icons-material';
import ProductHierarchyTree from './ProductHierarchyTree';
import HierarchyNodeDetail from './HierarchyNodeDetail';
import HierarchyStatistics from './HierarchyStatistics';
import HierarchyNodeForm from './HierarchyNodeForm';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const ProductHierarchyPage = () => {
  const [selectedView, setSelectedView] = useState(0);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [nodeToEdit, setNodeToEdit] = useState(null);
  
  const handleNodeSelect = (nodeId) => {
    setSelectedNodeId(nodeId);
    setSelectedView(2); // Switch to node detail view
  };
  
  const handleBackToTree = () => {
    setSelectedNodeId(null);
    setSelectedView(0); // Back to tree view
  };
  
  const handleCreateNode = () => {
    // Disabled for now
    console.log('Node creation is currently disabled');
  };
  
  const handleEditNode = (node) => {
    // Disabled for now
    console.log('Node editing is currently disabled');
  };
  
  const handleFormSuccess = () => {
    setFormOpen(false);
    // Refresh data as needed
    if (selectedView === 0) {
      // Refresh tree - would need to add a ref or state to trigger refresh
    } else if (selectedView === 2 && selectedNodeId) {
      // Refresh node details - would need to add a ref or state to trigger refresh
    }
  };
  
  const handleTabChange = (event, newValue) => {
    // If switching away from node detail view, clear selected node
    if (selectedView === 2 && newValue !== 2) {
      setSelectedNodeId(null);
    }
    setSelectedView(newValue);
  };
  
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
            <Link color="inherit" href="/">
              Supply Chain
            </Link>
            <Typography color="text.primary">Product Hierarchy</Typography>
            {selectedView === 0 && <Typography color="text.primary">Tree View</Typography>}
            {selectedView === 1 && <Typography color="text.primary">Statistics</Typography>}
            {selectedView === 2 && <Typography color="text.primary">Node Details</Typography>}
          </Breadcrumbs>
          
          <Paper sx={{ mb: 2 }}>
            <Tabs 
              value={selectedView} 
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab icon={<AccountTreeIcon />} label="Hierarchy Tree" />
              <Tab icon={<BarChartIcon />} label="Statistics" />
              {selectedNodeId && <Tab label="Node Details" disabled={!selectedNodeId} />}
            </Tabs>
          </Paper>
        </Grid>
        
        <Grid item xs={12}>
          <TabPanel value={selectedView} index={0}>
            {selectedNodeId ? (
              <HierarchyNodeDetail 
                nodeId={selectedNodeId} 
                onBack={handleBackToTree} 
                onEdit={handleEditNode} // This is now a no-op function
                onNodeSelect={handleNodeSelect}
              />
            ) : (
              <ProductHierarchyTree 
                onNodeSelect={handleNodeSelect} 
                onCreateNode={handleCreateNode} // This is now a no-op function
              />
            )}
          </TabPanel>
          
          <TabPanel value={selectedView} index={1}>
            <HierarchyStatistics />
          </TabPanel>
          
          <TabPanel value={selectedView} index={2}>
            {selectedNodeId && (
              <HierarchyNodeDetail 
                nodeId={selectedNodeId}
                onBack={handleBackToTree}
                onEdit={handleEditNode}
                onNodeSelect={handleNodeSelect}
              />
            )}
          </TabPanel>
        </Grid>
      </Grid>
      
      {/* Hide the form dialog completely
      <HierarchyNodeForm 
        open={formOpen} 
        nodeData={nodeToEdit} 
        onClose={() => setFormOpen(false)} 
        onSuccess={handleFormSuccess}
      />
      */}
    </Container>
  );
};

export default ProductHierarchyPage; 